import React, { useEffect, useState } from "react";
import { parseISO, formatDistance } from "date-fns";
import pt from "date-fns/locale/pt";
import { useAuth } from "../../../../context/ContextApi";
import Spinner from "react-bootstrap/Spinner";
import swal from "sweetalert";
import EmptyContent from "../../../../components/EmptyContent/EmptyContent";
import io from "socket.io-client";

import From from "../components/From";
import To from "../components/To";
import api from "../../../../config/api";
require("dotenv").config();

const ChatView = ({ selectedChat }) => {
  const [messages, setMessages] = useState([]);
  const [load, setLoad] = useState(true);
  const [commentBtn, setCommentBtn] = useState(false);
  const [comment, setComment] = useState("");
  const [newMessage, setNewMessage] = useState();
  const { userToken, userId } = useAuth();
  const room = selectedChat;

  useEffect(() => {
    const getMessages = async (token) => {
      if (!selectedChat) return;
      setLoad(true);
      try {
        const config = { headers: { Authorization: "Bearer " + token } };
        await api
          .get(`/replies/${selectedChat}?order=asc&limit=9999`, config)
          .then(function (response) {
            // console.log(response.data);
            const data = response.data.map((chat) => ({
              ...chat,
              timeDistance: formatDistance(parseISO(chat.createdAt), new Date(), {
                addSuffix: true,
                locale: pt,
              }),
            }));
            setMessages(data);
            setLoad(false);
            scrollDown();
          })
          .catch(function (error) {
            console.log(error);
            setLoad(false);
          });
      } catch (err) {
        console.log(err);
        setLoad(false);
      }
    };
    getMessages(userToken);
    // console.log('atualizou');
  }, [selectedChat, userToken]);

  useEffect(() => {
    scrollDown();
    if (!messages.length) {
      setLoad(false);
    }
  }, [messages]);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKETIO_URL, {
      transports: ["websocket", "polling"],
    });
    // socket.emit("join", selectedChat);
    socket.on("message", (message) => {
      let newMessage = {
        ...message,
        timeDistance: formatDistance(parseISO(message.createdAt), new Date(), {
          addSuffix: true,
          locale: pt,
        }),
      };
      setMessages((prevValue) => [...prevValue, newMessage]);
    });
    socket.on("connect", () => {
      socket.emit("join_chat", room);
    });
    return () => {
      socket.disconnect();
    };
  }, [selectedChat]);

  const sendMessage = () => {
    setCommentBtn(true);

    if (comment === "") {
      swal("Atenção!", "Digite alguma mensagem", "warning");
      setCommentBtn(false);
    }

    const data = {
      chat: selectedChat,
      from: userId,
      message: comment,
    };
    const config = { headers: { Authorization: "Bearer " + userToken } };
    api
      .post(`/replies`, data, config)
      .then(function (response) {
        const data = response.data.map((chat) => ({
          ...chat,
          timeDistance: formatDistance(parseISO(chat.createdAt), new Date(), {
            addSuffix: true,
            locale: pt,
          }),
        }));
        // console.log(data);
        setMessages(data);
        setCommentBtn(false);
        setComment("");
        scrollDown();
      })
      .catch(function (error) {
        setCommentBtn(false);
        // console.log(error);
      });
  };

  const scrollDown = () => {
    var objDiv = document.getElementById("reply-area");
    objDiv.scrollTop = objDiv.scrollHeight;
  };

  const handleEnv = (e) => {
    const eventKey = e.key;
    if (eventKey === "Enter") {
      sendMessage();
    }
  };

  return (
    <div className="col-lg-7 col-md-8  card mt-2 mt-lg-0 justify-content-between ">
      <div id="reply-area" className="overflow-auto p-3 w-100 h-100">
        {load ? (
          <div className="justify-content-center align-items-center d-flex h-100">
            <Spinner className="m-auto d-block" animation="border" variant="primary" />
          </div>
        ) : messages?.length === 0 ? (
          <div className="justify-content-center align-items-center d-flex mt-4">
            <div className="col-lg-8  mt-5">
              <EmptyContent description={"Não existem conversas recentes"} />
            </div>
          </div>
        ) : (
          messages.map((message, index) =>
            message?.from?._id === userId ? (
              <To message={message} key={index} />
            ) : (
              <From message={message} key={index} />
            )
          )
        )}
      </div>

      <div id="send-reply-container" className="d-flex">
        <div className="input-group">
          <input
            type="text"
            disabled={load === true || selectedChat?.length === 0}
            onKeyUp={(e) => handleEnv(e)}
            className="form-control fz-14 box-shadow-none text-cl-auroMetal ff-roboto"
            placeholder="Digite sua mensagem"
            name="comment"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
        <button
          type="submit"
          disabled={load === true || selectedChat?.length === 0}
          onClick={() => sendMessage()}
          className="ms-2 btn bg-gradient-theme-blue text-white py-2 fz-14 d-flex justify-content-center ff-univanova-medium"
        >
          {commentBtn ? <Spinner animation="border" variant="primary" /> : "Enviar"}
        </button>
      </div>
    </div>
  );
};

export default ChatView;
